import { GetResponseType } from '@make-software/tg-mini-app-ui';

import {
  GetFriendsResponseType,
  GetHypnowheelResponseType,
  PostOnboardingCompletedResponseType,
  GetUserResponseType,
  GetWalletConnectionResponseType,
  GetLeaderboardResponseType,
  PostWalletConnectionRequestType,
  PostWalletConnectionResponseType,
  SeasonInfoResponseType,
  GetVoteTransactionResponseType,
  GetActivityResponseType,
  GetVoteRankingResponseType,
  GetFantomRunResponseType, GetMakePrimaryResponseType, GetGiveawayDataResponseType
} from '@/entities';

import { getUser, completeOnboarding } from './user';
import {
  getWalletConnection,
  postWalletConnection,
  postWalletDisconnection,
  postWalletDownloaded
} from './wallet';
import { getFriends, pushFriend } from './friends';
import { getHypnowheel, getSpinData, postSpinCompleted } from './hypnowheel';
import { getVotesActivity, getVotesRanking, getVoteTransaction } from './vote';
import { getLeaderboardData } from './leaderboard';
import { collect } from './collect';
import { getSeasonInfo } from './season-info';
import { getFantomRunPlays } from './fantom-run';
import { claimSubname, getGiveawayData, makeSubnamePrimary, searchCSPRSubname } from './giveaway';

type TelegramClientApi = {
  getUser: (
    withBalances?: boolean,
    captchaToken?: string,
    tgInitData?: string
  ) => Promise<GetResponseType<GetUserResponseType>>;
  getFriends: (tgInitData?: string) => Promise<GetResponseType<GetFriendsResponseType>>;
  getWalletConnection: (
    account: string,
    tgInitData?: string
  ) => Promise<GetResponseType<GetWalletConnectionResponseType>>;
  postWalletConnection: (
    proof: PostWalletConnectionRequestType,
    tgInitData?: string
  ) => Promise<GetResponseType<PostWalletConnectionResponseType>>;
  postWalletDisconnection: (tgInitData?: string) => Promise<GetResponseType<void>>;
  postWalletDownloaded: (tgInitData?: string) => Promise<GetResponseType<void>>;
  getSeasonInfo: (tgInitData?: string) => Promise<GetResponseType<SeasonInfoResponseType>>;
  completeOnboarding: () => Promise<GetResponseType<PostOnboardingCompletedResponseType>>;
  collect: (payload: any) => Promise<GetResponseType<void>>;
  pushFriend: (friendId: string) => Promise<GetResponseType<any>>;
  getHypnowheel: (tgInitData?: string) => Promise<GetResponseType<GetHypnowheelResponseType>>;
  getSpinData: (tgInitData?: string) => Promise<GetResponseType<GetHypnowheelResponseType>>;
  postSpinCompleted: (
    nonce: string,
    tgInitData?: string
  ) => Promise<GetResponseType<GetHypnowheelResponseType>>;
  getLeaderboardData: (
    offset: number,
    limit: number
  ) => Promise<GetResponseType<GetLeaderboardResponseType>>;
  getVoteTransaction: (
    tokenAmount: number,
    projectHash: string
  ) => Promise<GetResponseType<GetVoteTransactionResponseType>>;
  getVotesActivity: (
    page?: number,
    pageSize?: number,
  ) => Promise<GetResponseType<GetActivityResponseType>>;
  getVotesRanking: () => Promise<GetResponseType<GetVoteRankingResponseType>>;
  getFantomRunPlays: () => Promise<GetResponseType<GetFantomRunResponseType>>;
  searchCSPRSubname: (
    subname: string,
  ) => Promise<GetResponseType<{ available: boolean }>>;
  getGiveawayData: () => Promise<GetResponseType<GetGiveawayDataResponseType>>;
  claimSubname: (
    subname: string,
  ) => Promise<GetResponseType<{ tx_hash: string }>>;
  makeSubnamePrimary: (
    subname: string,
  ) => Promise<GetResponseType<GetMakePrimaryResponseType>>;
};

export const telegramClientApi: TelegramClientApi = {
  getUser,
  getFriends,
  getWalletConnection,
  postWalletConnection,
  postWalletDisconnection,
  postWalletDownloaded,
  getSeasonInfo,
  completeOnboarding,
  collect,
  pushFriend,
  getHypnowheel,
  getSpinData,
  postSpinCompleted,
  getLeaderboardData,
  getVoteTransaction,
  getVotesActivity,
  getVotesRanking,
  getFantomRunPlays,
  searchCSPRSubname,
  getGiveawayData,
  claimSubname,
  makeSubnamePrimary,
};
